<template>
  <div class="flex-row flex-content-around bg-black pt-40 pb-22 container">
    <img class="w-150 h-168" src="@assets/images/logo_big.png" alt />
    <div class="flex-column-row-center">
      <div class="flex-column w-308 content-wrapper">
        <span class="OPPO-R fs-18 lh-18 brown-1">{{
          $t("footer.contact")
        }}</span>
        <span class="OPPO-R fs-18 lh-18 brown-1 mt-20">{{
          $t("footer.DUBAIOffice")
        }}</span>
        <span class="OPPO-L fs-15 lh-19 white mt-17 content"
          >{{ $t("footer.DUBAIAdress") }}<br />
          <a href="mailto:info@blacklocustcap.com" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white">{{
              $t("footer.DUBAIEmail")
            }}</span></a
          >
          <br /><a href="tel:+97148248861" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white">{{
              $t("footer.DUBAIPhone")
            }}</span></a
          ></span
        >
        <span class="OPPO-R fs-18 lh-18 brown-1 mt-21">{{
          $t("footer.CHINAOffice")
        }}</span>
        <span class="OPPO-L fs-15 lh-19 white mt-17 content">
          <a href="mailto:info@blacklocustcap.com" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white"
              >{{ $t("footer.CHINAAdress") }}<br />
              {{ $t("footer.CHINAEmail") }}</span
            ></a
          >
          <br />{{ $t("footer.CHINAContactPerson") }}<br />{{
            $t("footer.CHINAContactNumber")
          }}<br />
          <a href="tel:+8602162713711" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white">{{
              $t("footer.CHINALandline")
            }}</span></a
          ></span
        >
        <span class="OPPO-R fs-18 lh-18 brown-1 mt-21">{{
          $t("footer.MALAYSIAOffice")
        }}</span>
        <span class="OPPO-L fs-15 lh-19 white mt-17 content"
          ><a href="mailto:info@blacklocustcap.com" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white"
              >{{ $t("footer.MALAYSIAAdress") }}<br />{{
                $t("footer.MALAYSIAEmail")
              }}</span
            ></a
          >
          <br /><a href="tel:+6087427745" class="no-underline">
            <span class="OPPO-L fs-15 lh-19 white">{{
              $t("footer.MALAYSIAPhone")
            }}</span></a
          ></span
        >
      </div>
      <span class="OPPO-R fs-14 lh-15 gray-3 mt-38 none"
        >© 2024. Black Locust Limited. All Rights Reserved</span
      >
    </div>
    <div class="flex-column about">
      <span class="OPPO-R fs-18 lh-18 brown-1">{{ $t("footer.aboutUs") }}</span>
      <span
        class="OPPO-L fs-15 lh-35 white mt-12 pointer"
        @click.stop="onClickAboutUs"
        >{{ $t("footer.requirements") }}</span
      >
      <span
        class="OPPO-L fs-15 lh-35 white pointer"
        @click.stop="onClickPrivacy"
        >{{ $t("footer.policy") }}</span
      >
      <span
        class="OPPO-L fs-15 lh-35 white pointer"
        @click.stop="onClickTerms"
        >{{ $t("footer.terms") }}</span
      >
    </div>

    <span class="OPPO-R fs-14 lh-15 gray-3 mt-38 display-none visible"
      >© 2024. Black Locust Limited. All Rights Reserved</span
    >
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    onClickAboutUs() {
      console.log("onClickAboutUs");
      this.$router.push({ name: "homeUserNotice" });
    },
    onClickPrivacy() {
      console.log("onClickPrivacy");
      this.$router.push({ name: "homePrivacy" });
    },
    onClickTerms() {
      console.log("onClickTerms");
      this.$router.push({ name: "homeTerms" });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .content-wrapper {
      width: 100%;
      margin-top: 20px;
      justify-content: center;
      align-items: center;
      .content {
        text-align: center;
      }
    }
    .none {
      display: none;
    }
    .visible {
      display: block;
    }
    .about {
      margin-top: 37px;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
